import {
  pgTable,
  serial,
  varchar,
  integer,
  timestamp,
} from "drizzle-orm/pg-core"
import { relations } from "drizzle-orm"
import { pagesTable } from "./Pages"
import { CUSTOMERS_LOGOS_SLIDERS } from "$types/PAGE_LAYOUTS"

export const customersLogosTable = pgTable("CustomersLogos", {
  id: serial().primaryKey(),
  partialKey: varchar({ length: 255 }).notNull(),
  order: integer(),
  slider: varchar({ length: 255 }).$type<CUSTOMERS_LOGOS_SLIDERS>().notNull().default(CUSTOMERS_LOGOS_SLIDERS.TOP),
  publishedAt: timestamp({ withTimezone: true }),
  alt: varchar(),
})

export const customersLogosRelations = relations(
  customersLogosTable,
  ({ one }) => ({
    page: one(pagesTable, {
      fields: [customersLogosTable.id],
      references: [pagesTable.customerLogoId],
    }),
  }),
)

export type CustomerLogoSchema = typeof customersLogosTable.$inferSelect
export type NewCustomerLogoSchema = typeof customersLogosTable.$inferInsert
